/**
 * i18n – single entry point for translations.
 *
 * How it works:
 * - English (en) is the source of truth in locales/en.js.
 * - Each other locale can be partial; missing keys fall back to English.
 * - To add a language: add locales/xx.js (at least { 'lang.xx': 'Language name' }) and register below.
 */

import en from './locales/en.js'
import es from './locales/es.js'
import pt from './locales/pt.js'
import ja from './locales/ja.js'
import zh from './locales/zh.js'
import hi from './locales/hi.js'
import fr from './locales/fr.js'
import it from './locales/it.js'
import de from './locales/de.js'
import ar from './locales/ar.js'

const rawLocales = { en, es, pt, ja, zh, hi, fr, it, de, ar }

/** Merge a locale with en so missing keys fall back to English. */
function mergeWithEn(localeObj) {
  if (!localeObj || typeof localeObj !== 'object') return { ...en }
  return { ...en, ...localeObj }
}

/** Full translations: every language merged with en. */
export const translations = Object.fromEntries(
  Object.entries(rawLocales).map(([code, strings]) => [code, mergeWithEn(strings)])
)

/** Language selector: English, Spanish, Portuguese, Japanese, Chinese, Hindi, French, Italian, German, Arabic. */
export const supportedLanguages = [
  { code: 'en', labelKey: 'lang.en', flag: '🇺🇸' },
  { code: 'es', labelKey: 'lang.es', flag: '🇪🇸' },
  { code: 'pt', labelKey: 'lang.pt', flag: '🇵🇹' },
  { code: 'ja', labelKey: 'lang.ja', flag: '🇯🇵' },
  { code: 'zh', labelKey: 'lang.zh', flag: '🇨🇳' },
  { code: 'hi', labelKey: 'lang.hi', flag: '🇮🇳' },
  { code: 'fr', labelKey: 'lang.fr', flag: '🇫🇷' },
  { code: 'it', labelKey: 'lang.it', flag: '🇮🇹' },
  { code: 'de', labelKey: 'lang.de', flag: '🇩🇪' },
  { code: 'ar', labelKey: 'lang.ar', flag: '🇦🇪' },
]

export default translations
